import { useStepperStore } from '../../../stores/stepper.store.js';
import { Ref, watch } from 'vue';
import { set } from '@vueuse/core';

export function useStore(selectedProduct: Ref<number | null>) {
  useStepperStore().subscribe((curr, prev) => {
    if (curr.extras.card?.variantId !== prev.extras.card?.variantId) {
      set(selectedProduct, curr.extras.card?.variantId ?? null);
    }
  });

  watch(selectedProduct, (cardId: number | null): void => {
    if (cardId) {
      useStepperStore().getState().extras.selectCard();
      useStepperStore().getState().extras.setCard(cardId);
    } else {
      useStepperStore().getState().extras.removeCard();
    }
  });
}
